import Button from '@jetbrains/ring-ui/components/button/button'
import {memo, useCallback} from 'react'

import {setRelativeTimeInBuildlog} from '../../../BuildLog.actions'
import {getRelativeTimeInBuildlog} from '../../../BuildLog.selectors'

import {useAppDispatch, useAppSelector} from 'src/hooks/react-redux'

type Props = {
  className?: string
}

function RelativeTimeButton({className}: Props) {
  const enabled = useAppSelector(getRelativeTimeInBuildlog)
  const dispatch = useAppDispatch()
  const toggle = useCallback(() => {
    dispatch(setRelativeTimeInBuildlog(!enabled))
  }, [dispatch, enabled])

  return (
    <Button text onClick={toggle} className={className}>
      {`${enabled ? 'Disable' : 'Enable'} relative time`}
    </Button>
  )
}

export default memo(RelativeTimeButton)
